__turbopack_context__.v({
  "buttonContainer": "nXoY-a_buttonContainer",
  "messageWrapper": "nXoY-a_messageWrapper",
  "selector": "nXoY-a_selector",
  "selectorButton": "nXoY-a_selectorButton",
  "selectorDialog": "nXoY-a_selectorDialog",
  "selectorLabel": "nXoY-a_selectorLabel",
});
